<div
  class="tab-pane fade flex-even active show"
  id="sales"
  role="tabpanel"
  aria-labelledby="sales-tab"
  >
  <div class="d-flex flex-column h-100">
    @if (this.insurances$ | async; as insurances) {
      @if (insurances.length == 0) {
        <div class="row mt-2">
          <div class="col-12 col-md">
            <div class="ps-3">
              <button
                type="button"
                [class]="ButtonType.Primary | buttontypepipe"
                class="btn-sm btn"
                translate
                (click)="openModalAddInsurance()"
                >
                SALES_TEAM_LBL_EXTERNAL_ACCOUNT_ADD
              </button>
            </div>
          </div>
        </div>
      }
      @if (insurances.length > 0) {
        <div class="row mt-2">
          <div class="col">
            <table class="table table-striped border-bottom">
              <thead>
                <tr>
                  <th>
                    <a translate>SALES_TEAM_LBL_EXTERNAL_ACCOUNT_COMPANY</a>
                  </th>
                  <th>
                    <a translate>SALES_TEAM_LBL_EXTERNAL_ACCOUNT_USERNAME</a>
                  </th>
                  <th>
                    <a translate>SALES_TEAM_LBL_EXTERNAL_ACCOUNT_ACTIONS</a>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (insurance of insurances; track insurance) {
                  <tr>
                    <td>{{ insurance.externalAccountTypeLoc }}</td>
                    <td>{{ insurance.username }}</td>
                    <td>
                      @for (action of insurance.actions; track action; let last = $last) {
                        <a role='button'
                          (click)="this.triggerAction(action.name, insurance.id)"
                        translate>{{ action.actionName }}{{ last ? '' : ' | ' }}</a>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    }
  </div>
</div>
